import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const Wrapper = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	justify-content: 'center';
	flex-grow: 1;
	margin-top: ${(props) => (props?.isAgent ? '0px' : isMobile ? '30px' : '32px')};
	width: ${(props) => (isMobile ? 'calc(100% - 20px)' : props.wrapperWidth || '100%')};
	max-width: ${isMobile ? '640px' : '100%'};
	@media (max-width: 1158px) {
		width: 90%;
		max-width: 90%;
	}
`;
